import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-modal-reuse-signatures',
  templateUrl: './modal-reuse-signatures.component.html',
  styleUrls: ['./modal-reuse-signatures.component.scss']
})
export class ModalReuseSignaturesComponent implements OnInit {

  @Output() closeModal = new EventEmitter();
  @Output() confirmModal = new EventEmitter();
  @Input() isMoreThanOneRejected: boolean;

  constructor() { }

  ngOnInit(): void {
  }
}
